import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import commonProps from './common/common-props';
import Header from './common/header';
import SiteMap from './common/site-map';
import Footer from './common/footer';
import JoinForm from './common/join-form';
import Hero from './features-elements/hero';
import TrendingContent from './features-elements/trending-content';
import FollowTrustedFunds from './features-elements/follow-trusted-funds';
import WrapUpEmails from './features-elements/wrap-up-emails';
import ReachOut from './features-elements/reach-out';

const Container = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
`;

export default function Features(props) {
  const common = commonProps();
  const state = {
    ...props,
    ...common,
    light: false,
  };

  return (
    <ThemeProvider theme={state}>
      <Container>
        <Header />
        <Hero />
        <TrendingContent />
        <FollowTrustedFunds />
        <WrapUpEmails />
        <ReachOut />
        {!common.isUserSignedIn && <JoinForm />}
        <SiteMap />
        <Footer />
      </Container>
    </ThemeProvider>
  );
}

/* eslint-disable react/no-unused-prop-types */
Features.propTypes = {
  logo: PropTypes.string.isRequired,
  hero: PropTypes.string.isRequired,
  heroPortrait: PropTypes.string.isRequired,
};
/* eslint-enable react/no-unused-prop-types */
